<template>
  <div class="article-stats">
    <ul class="article-stats__content">
      <li class="article-stats__item article-stats__item--logo">
        <router-link
          class="article-stats__link"
          :to="{
            name: 'blog__root',
            params: { gameNamespace: currentGameRouteName }
          }">
          <img
            :src="GameModel.getGameLogo(article.category.game_id)"
            alt=""
            class="article-stats__logo"
            width="32"
            height="32">
        </router-link>
      </li>

      <li class="article-stats__item article-stats__item--tag">
        <router-link
          class="article-stats__link article-stats__tag"
          :to="{
            name: 'blog__root',
            params: { gameNamespace: currentGameRouteName, categorySlug: article.category.slug }
          }">
          {{ article.category.title }}
        </router-link>
      </li>

      <li class="article-stats__item article-stats__block article-stats__item--date">
        <p class="article-stats__description">
          Last Updated:
        </p>

        <p class="article-stats__text">
          {{ currentDate }}
        </p>
      </li>

      <li
        v-if="article.blog_author"
        class="article-stats__item article-stats__block article-stats__item--date">
        <p class="article-stats__description">
          By:
        </p>

        <img
          class="article-stats__author-avatar"
          :src="authorAvatar"
          :alt="article.blog_author.name">

        <router-link :to="{ name: 'blog__author', params: { authorSlug: article.blog_author.slug } }">
          {{ article.blog_author.name }}
        </router-link>
      </li>

      <!--      <li class="article-stats__item article-stats__block article-stats__item&#45;&#45;views">-->
      <!--        <img-->
      <!--          src="/images/icons/eye.svg"-->
      <!--          width="24"-->
      <!--          height="24"-->
      <!--          alt=""-->
      <!--          class="article-stats__icon">-->

      <!--        <p class="article-stats__text">-->
      <!--          {{ article.views_count }} views-->
      <!--        </p>-->
      <!--      </li>-->

      <li class="article-stats__item article-stats__block article-stats__item--rates">
        <img
          src="/images/icons/star.svg"
          width="24"
          height="24"
          alt=""
          class="article-stats__icon">

        <p class="article-stats__text">
          {{ article.rating }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import GameModel from 'Models/GameModel';
import { getDateParts } from 'Root/helpers/tools';

export default {
  name: 'ArticleStats',

  props: {
    article: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {
      GameModel,
    };
  },

  computed: {
    currentDate() {
      const {
        day,
        month,
        year,
      } = getDateParts(this.article.updated_at);

      return `${day}.${month}.${year}`;
    },

    currentGameRouteName() {
      return this.$route.params?.gameNamespace;
    },

    authorAvatar() {
      return `/storage/${this.article.blog_author.avatar}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .article-stats__content {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: -16px;
    margin-right: -16px;
  }

  .article-stats__item {
    margin-top: 16px;
    margin-right: 16px;
    flex-shrink: 0;

    a {
      color: $color--basic-white;
    }
  }

  .article-stats__item--logo {
    font-size: 0;
  }

  .article-stats__item--tag {
    max-width: 100%;
    flex-shrink: 1;
    min-width: 0;
  }

  .article-stats__logo {
    width: 32px;
    height: 32px;
    line-height: 0;
  }

  .article-stats__link {
    display: inline-block;
  }

  .article-stats__tag {
    padding: 0.6em 1.2em;
    font-size: $text-13px;
    font-weight: 500;
    line-height: 1.2;
    border-radius: 50px;
    background-color: $color--basic-blue;
    color: $color--basic-white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    max-width: 100%;
  }

  .article-stats__block {
    display: flex;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }

  .article-stats__description {
    color: $color--basic-dark-gray;
  }

  .article-stats__text {
    color: $color--basic-white;
  }

  .article-stats__icon {
    --article-stats-icon-size: 24px;

    width: var(--article-stats-icon-size);
    height: var(--article-stats-icon-size);
    margin-right: 8px;
  }

  .article-stats__author-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  @media only screen and #{$screen-less-than-1024} {
    .article-stats__item--date {
      flex-direction: column;
      align-items: flex-start;

      > *:not(:first-child) {
        margin-top: 8px;
      }
    }
  }

  @media screen and (max-width: 540px) {
    .article-stats__content {
      margin-top: -8px;
      margin-right: -8px;
      justify-content: space-between;
    }

    .article-stats__item {
      margin-top: 8px;
      margin-right: 8px;
    }

    .article-stats__item--tag {
      width: 100%;
      margin-top: 16px;
      order: 1;

      .article-stats__tag {
        width: inherit;
      }
    }

    .article-stats__item--views {
      max-width: calc(100% - 32px - 75px - 50px - (8px * 4));
    }

    .article-stats__content {
      flex-wrap: wrap;
    }
  }

  @media only screen and #{$screen-more-or-1024} {
    .article-stats__block {
      font-size: 13px;
    }

    .article-stats__item--date {
      flex-direction: row;

      > *:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
</style>
